import React from 'react'
import { Bar, CartesianGrid, ComposedChart, ResponsiveContainer, XAxis, YAxis, Tooltip, LabelList, Cell, Label } from 'recharts'
import { formatNumberWithCommas } from '../../../utils/utils';
import { findMinMax } from "../ChartUtils";

// const getPath = (x, y, width, height, borderRadius = 5) => {
//     const adjustedRadius = Math.min(borderRadius, width / 2, height / 2); // Ensure radius doesn't exceed dimensions

//     return `
//     M${x},${y} 
//     H${x + width - adjustedRadius} 
//     A${adjustedRadius},${adjustedRadius} 0 0 1 ${x + width},${y + adjustedRadius} 
//     V${y + height - adjustedRadius} 
//     A${adjustedRadius},${adjustedRadius} 0 0 1 ${x + width - adjustedRadius},${y + height} 
//     H${x} 
//     V${y} 
//     Z
//   `;
// };

// const CircularBar = (props) => {
//     const { fill, x, y, width, height, value } = props;
//     const formattedValue = formatNumberWithCommas(value);
//     return (
//         <>
//             <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />
//             {/* Add label at the end of the bar */}
//             <text
//                 x={x + width + 5} // Position slightly beyond the bar
//                 y={y + height / 2} // Centered vertically
//                 fill="#333"
//                 fontSize="12"
//                 dominantBaseline="middle"
//             >
//                 {formattedValue}
//             </text>
//         </>
//     );
// };

// function findMinMax(data) {
//     let values = [];
    
//     data?.forEach(item => {
//         Object.keys(item).forEach(key => {
//             if (key !== "segmentName" && item[key] !== null) {
//                 const num = parseFloat(item[key]);
//                 if (!isNaN(num)) {
//                     values.push(num);
//                 }
//             }
//         });
//     });
    
//     return {
//         min: Math.min(...values),
//         max: Math.max(...values)
//     };
// }

const generateTicks = (minValue, maxValue) => {
    const start = Math.ceil(minValue / 5) * 5;
    const end = Math.floor(maxValue / 5) * 5;
    const ticks = [];
    for (let i = start-25; i <= 0; i += 25) {
        ticks.push(i);
    }
    if (!ticks.includes(0)) {
        ticks.push(0);
    }
    for (let i = 0; i <= end+25; i += 25) {
        ticks.push(i);
    }
    return ticks;
};
const CustomTooltip = ({ active, payload, label }) => {
	if (active && payload && payload.length) {
		return (
			<div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10 }}>
				<div >{`${payload[0]['payload']['segmentName']}`}</div>
				{/* {payload[0]['payload']['actual'] && 
                    <div style={{ color: "#0078A7" }}>Actual: {`${payload[0]['payload']['actual']}`}</div> } */}
				{payload[0]['payload']['npsScore'] && 
                    <div style={{ color: "" }}>NPS Score: {`${payload[0]['payload']['npsScore']}`}</div> }
				{payload[0]['payload']['responseCount'] && 
                    <div ># of Responses: {`${payload[0]['payload']['responseCount']}`}</div>}
			</div>
		);
	}

	return null;
};
function NpsBarChart({ data }) {
    const result = findMinMax(data,"segmentName");
    
    const roundUpToNearest5 = (value) => Math.floor(value / 5) * 5;
    const roundUpToNearest5Positive = (value) => Math.ceil(value / 5) * 5;
    const minValue = result?.min>0?0:roundUpToNearest5(result?.min)
    const maxValue = result?.max<0?0:roundUpToNearest5Positive(result?.max)

    

      const getBarColor = (value) => {
        if (value < 0) return '#D20000';    // Red
            else if (value >= 0 && value <=10) return '#ff891c';    // Orange
            else if (value >= 10 && value <=30 ) return '#FFB933';    // Yellow
            else if (value >= 30 && value <=50 ) return '#66CC66';    // light green // #B3DACB
            return '#008251';                     // Dark Green
        };             
      

      const chartHeight = data?.length<3?data?.length * 120:data?.length * 80;
      const CustomCombinedLabel = ({ x, y, width, value, chartData, index }) => {
        const npsScore = chartData[index].npsScore;
        const responsesCount = chartData[index].responseCount;
        
        // Determine dx based on npsScore
        const dxAdjust = Number(npsScore) < 0 ? -35 : 5;
      
        return (
          <text
            x={x + width + dxAdjust}
            y={y}
            fill="#000"
            dy={10}
            dx = {dxAdjust}
          >
            {npsScore} ({responsesCount})
          </text>
        );
      };
      

    return (
        <>
        <div style={{ width: "100%", maxHeight: "450px", overflowY: "auto" }}>
            {/* <div style={{ width: '100%', height: `${data.length > 1 ? data.length * 50 : data.length * 100}px` }}> */}
            <div style={{ width: '100%', height: chartHeight }}>
                {/* <ResponsiveContainer width="100%" height={"100%"} > */}
                <ResponsiveContainer width="100%" height={chartHeight} >
                    <ComposedChart
                        layout="vertical"
                        data={data}
                        margin={{
                            top: 20,
                            right: 30,
                            bottom: 25,
                            left: -50,
                        }}
                    >
                        <CartesianGrid horizontal={false} vertical={true} />
                        <XAxis
                            dataKey={"npsScore"}
                            // label={{ value: xAxisLabel, offset: 9, position: "bottom", fill: '#616161' }}
                            type="number"
                            domain={[minValue,maxValue]} // * 1.2
                            axisLine={false} tickLine={false}
                            ticks={generateTicks(minValue, maxValue)}
                            // ticks={[...Array(6)].map((_, i) => Math.round((Math.round(chartMaxValue) / 5) * i))} // * 1.2
                            tickFormatter={formatNumberWithCommas} />
                        <YAxis dataKey={"segmentName"} tick={{ fontSize: 12, fontWeight: 500 }} type="category" scale="auto" axisLine={false} tickLine={false} width={270} />
                        <Tooltip content={<CustomTooltip />} />
                        {/* <Bar
                            dataKey={"actual"}
                            shape={<CircularBar />}
                            barSize={10}
                            fill="#0078A7"
                        /> */}
                        {/* <Bar
                            dataKey={"npsScore"}
                            shape={<CircularBar />}
                            barSize={10}
                            fill="#B05788"
                        /> */}
                        {/* <Bar
                            dataKey={"forecast"}
                            shape={<CircularBar />}
                            barSize={10}
                            fill="#FF891C"
                        /> */}
                        {/* <Bar
                            dataKey={"actual"}
                            barSize={10}
                            radius={[0, 10, 10, 0]} 
                            fill="#0078A7"
                        /> */}
                        {/* <Bar
                            dataKey="npsScore"
                            barSize={10}
                            radius={[0, 10, 10, 0]} 
                            fill={""}
                        /> */}
                        <Bar dataKey="npsScore" radius={[0,10,10,0]} barSize={10}>
                            {data?.map((entry, index) => (
                                <>
                            <Cell key={`cell-${index}`} fill={getBarColor(entry.npsScore)} />
                            {/* <LabelList dataKey="npsScore" position="right" content={<CustomLabel dataKey="npsScore" npsScore={entry.npsScore}/>} />
                            <LabelList dataKey="responseCount" position="right" content={<CustomLabel dataKey="responseCount" npsScore={entry.npsScore}/>} /> */}
                            </>
                            ))}
                            <LabelList
                                content={<CustomCombinedLabel chartData={data} />}
                                position="right"
                                />
                            
                        </Bar>
                        {/* {data.map((entry, index) => (
                                <Bar
                                key={entry.segmentName} // Ensure each bar has a unique key
                                dataKey="npsScore"
                                barSize={10}
                                radius={[0, 10, 10, 0]}
                                fill={getColor(entry.npsScore)}
                                >
                                <LabelList dataKey="npsScore" position="top" />
                                </Bar>
                            ))} */}
                        {/* <LabelList dataKey="npsScore" position="top"  /> */}
                        {/* <Bar
                            dataKey={"forecast"}
                            barSize={10}
                            radius={[0, 10, 10, 0]} 
                            fill="#FF891C"
                        /> */}
                    </ComposedChart>
                </ResponsiveContainer>
            </div>
        </div>
        <div className='nps-score-regionnpschart'>NPS Score</div>
        </>
    )
}

export default NpsBarChart
